export default "__VITE_ASSET__DwVwuTTd__"